import React from 'react';
import { Row } from '../../../../../components/row/Row';
import { LocationTypes } from '../locationTypes';
import { FontAwesomeIcon } from './../../../../../utilities/iconLoader/FontAwesomeIcon';

export const Rating = ({
  rating,
  size = 16,
  fillColor = '#FD8E39',
  maxRating = 5,
  totalReviews,
}: LocationTypes.IRating) => {
  const fullStarsToDisplay = Math.floor(rating);

  const renderTotalReviews = () => {
    if (totalReviews) {
      return <>({totalReviews})</>;
    }
    return <></>;
  };
  const renderStars = () => {
    // create an array;
    const starsToRender = [];
    for (let noOfStars = 0; noOfStars < maxRating; noOfStars++) {
      if (noOfStars < fullStarsToDisplay) {
        starsToRender.push(1); // fullFilledStar
      } else if (noOfStars >= fullStarsToDisplay && noOfStars < rating) {
        starsToRender.push(0.5); // halfFilledStar
      } else {
        starsToRender.push(0); // EmptyStar
      }
    }
    if (starsToRender.length === 0) {
      return <></>;
    }
    return starsToRender.map((star, index) => {
      if (star === 1) {
        return (
          <FontAwesomeIcon
            iconContextProps={{
              color: fillColor,
              style: {
                fontSize: size,
              },
            }}
            iconClassName="FaStar"
            key={`starToRender-${index}-${star}`}
          />
        );
      }
      if (star === 0.5) {
        return (
          <FontAwesomeIcon
            iconContextProps={{
              color: fillColor,
              style: {
                fontSize: size,
              },
            }}
            iconClassName="FaStarHalfAlt"
            key={`starToRender-${index}-${star}`}
          />
        );
      }
      return (
        <FontAwesomeIcon
          iconContextProps={{
            color: fillColor,
            style: {
              fontSize: size,
            },
          }}
          iconClassName="FaRegStar"
          key={`starToRender-${index}-${star}`}
        />
      );
    });
  };
  return (
    <Row className="ratingsRow">
      <p>{rating} </p>
      <p>{renderStars()} </p>
      <p>{renderTotalReviews()}</p>
    </Row>
  );
};
